import PricingComparison from './pricing-comparison';
export default PricingComparison;
